export default __webpack_public_path__ + "static/media/O-071.84b1d6a4.png";